// extracted by mini-css-extract-plugin
module.exports = {"container":"ContainerV2_container__w9qEV","fluid":"ContainerV2_fluid__UR2tK","padded":"ContainerV2_padded__aTapb","wrapper":"ContainerV2_wrapper__9AQ9U"};